import React from "react";
import { Table } from "react-bootstrap";
import { Bubble } from "ctia-ui";
import LabResultRowOta from "components/labRequest/LabResultRowOta";

const LabResultListOta = ({ list }) => {
  if (!list) return null;

  return (
    <div>
      <Bubble>
        You may enter the test results for a request by clicking on the{" "}
        <strong>Request ID</strong>.
      </Bubble>
      <Table striped condensed hover className="ctia-table">
        <thead>
          <tr>
            <th>Request ID</th>
            <th>Vendor</th>
            <th>Model Name/Number</th>
            <th>Request Type</th>
          </tr>
        </thead>
        <tbody>
          <LabResultRowOta tableRows={list} />
        </tbody>
      </Table>
    </div>
  );
};

export default LabResultListOta;
